<template>
  <div>
    <!--设置网址title-->
    <div v-wechat-title="$route.meta.title='理捷管理系统'"></div>
    <!--返回上一页-->
    <div class="backBg">
      <a href="javascript:history.go(-1)">
        <div class="backBox">
          <span class="backIcon"></span>
        </div>
      </a>
      <div class="topTitle">
        <span >单号查询</span>
      </div>
    </div>
    <div class="content_bg">
      <div class="o_blue_box">
        <!--搜索框-->
        <div class="searchBg">
          <div class="weui-search-bar" id="searchBar" ref="searchBar">
            <form class="weui-search-bar__form">
              <div class="weui-search-bar__box">
                <i class="weui-icon-search"></i>
                <input type="search" class="weui-search-bar__input" id="searchInput" ref="searchInput" placeholder="搜索单号查询~" required @blur="blurSearch" @input="checkSearch"/>
                <a href="javascript:" class="weui-icon-clear" id="searchClear" ref="searchClear" @click="clearSearch"></a>
              </div>
              <label class="weui-search-bar__label" id="searchText" ref="searchText" @click="clickSearch">
                <i class="weui-icon-search"></i>
                <span>搜索单号查询~</span>
              </label>
            </form>
            <a href="javascript:" class="weui-search-bar__cancel-btn" id="searchSubmit" ref="searchSubmit" @click="search">取消</a>
          </div>
        </div>

        <!--列表-->
        <div class="check_list_bg">
          <div class="check_list_box" v-for="item,index in orderList">
            <div class="check_list_w">
              <div class="d_f_box">
                <div class="d_f_1">
                  <p>制造单号：{{ order_no }}</p>
                </div>
                <!--<p class="order_date">2019-10-08</p>-->
              </div>
              <div class="d_f_box" @click="getSizeDetail(1,item.part1_in_num,item.order_id)">
                <div class="d_f_1">
                  <p class="color_4598FF">针车中仓入库数</p>
                </div>
                <p :class="item.part1_in_num > 0 ? 'data_icon':''">{{ item.part1_in_num }}件</p>
              </div>
              <div class="d_f_box" @click="getSizeDetail(2,item.part1_out_num,item.order_id)">
                <div class="d_f_1">
                  <p class="color_4598FF">针车中仓出库数</p>
                </div>
                <p :class="item.part1_out_num > 0 ? 'data_icon':''">{{ item.part1_out_num }}件</p>
              </div>
              <div class="d_f_box" @click="getSizeDetail(6,item.part1_wrong_num,item.order_id)">
                <div class="d_f_1">
                  <p class="color_4598FF">针车不良数</p>
                </div>
                <p :class="item.part1_wrong_num > 0 ? 'data_icon color_f24242':''">{{ item.part1_wrong_num }}件</p>
              </div>
              <div class="d_f_box" @click="getSizeDetail(3,item.part2_in_num,item.order_id)">
                <div class="d_f_1">
                  <p class="color_4598FF">成型中仓入库数</p>
                </div>
                <p :class="item.part2_in_num > 0 ? 'data_icon':''">{{ item.part2_in_num }}件</p>
              </div>
              <div class="d_f_box" @click="getSizeDetail(4,item.part2_out_num,item.order_id)">
                <div class="d_f_1">
                  <p class="color_4598FF">成型中仓出库数</p>
                </div>
                <p :class="item.part2_out_num > 0 ? 'data_icon':''">{{ item.part2_out_num }}件</p>
              </div>
              <div class="d_f_box" @click="getSizeDetail(5,item.part3_in_num,item.order_id)">
                <div class="d_f_1">
                  <p class="color_4598FF">成品入库数</p>
                </div>
                <p :class="item.part3_in_num > 0 ? 'data_icon':''">{{ item.part3_in_num }}件</p>
              </div>
              <div class="d_f_box" @click="getSizeDetail(7,item.part2_wrong_num,item.order_id)">
                <div class="d_f_1">
                  <p class="color_4598FF">成型不良品数</p>
                </div>
                <p :class="item.part2_wrong_num > 0 ? 'data_icon color_f24242':''">{{ item.part2_wrong_num }}件</p>
              </div>
              <div class="d_f_box" @click="getSizeDetail(8,item.part3_wrong_num,item.order_id)">
                <div class="d_f_1">
                  <p class="color_4598FF">装配不良数</p>
                </div>
                <p :class="item.part3_wrong_num > 0 ? 'data_icon color_f24242':''">{{ item.part3_wrong_num }}件</p>
              </div>
              <!--<div class="get_more_box">-->
                <!--<span class="get_more_btn get_more_arr" ref="get_more" @click="getMore(index)">查看更多</span>-->
              <!--</div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <loading v-show="loading"></loading>
  </div>
</template>

<script>
  import { webToast } from "@/assets/js/alertPopShow";
  import loading from '@/components/loading'
  export default {
    name:'orderCheck',
    components:{
      loading,
    },
    data(){
      return{
        orderList:'',
//        当前制作单号
        order_no:'',
        loading:false,
      }
    },
    created:function () {
      var that = this;
//    配置微信jssdk
      var url = window.location.href.split('#')[0];
      that.app.wxjssdk(url);
    },
    methods:{
//      点击搜索框
      clickSearch(){
        this.$refs.searchBar.classList.add('weui-search-bar_focusing');
        this.$refs.searchInput.focus();
      },
//      取消搜索
      cancelSearch(){
        this.$refs.searchBar.classList.remove('weui-search-bar_focusing');
        this.$refs.searchInput.blur();
      },
//      清除搜索内容
      clearSearch(){
        this.$refs.searchInput.focus();
        this.$refs.searchInput.value = '';
        this.$refs.searchSubmit.innerHTML = '取消';
      },
//      搜索框失去焦点
      blurSearch(){
        if(!this.$refs.searchInput.value.length){
          this.cancelSearch();
          this.$refs.searchSubmit.innerHTML = '取消';
        }
      },
//      监听搜索
      checkSearch(){
        if(this.$refs.searchInput.value.length){
          this.$refs.searchSubmit.innerHTML = '搜索';
        }
      },
//      点击搜索
      search(){
        var that = this;
        var token = localStorage.getItem('token');
        var formData = new FormData();
        formData.append('token',token);
        if(this.$refs.searchInput.value.length){
          that.orderList = '';
          that.order_no = that.$refs.searchInput.value;
          that.loading = true;
          formData.append('order_no',this.$refs.searchInput.value);
          that.app.postData('/mhome.php/Count/searchOrderByNo',formData
            ,result =>{
              if( result.status == 503 ){
                webToast('暂无数据','middle',1500);
              }else{
                that.orderList = result.content.order_list;
              }
            },() =>{
              that.loading = false;
            })
        }
      },
//      查看编码详情
      getSizeDetail(type,num,order_id){
        var that = this;
        if( num > 0 ){
          that.$router.push({ name:'sizeDetail',query:{ order_id:order_id,type:type } });
          return false;
        }else{
          webToast('暂无数据','middle',1500);
        }
      },
//      展开列表
      getMore(index){
        var get_more = this.$refs.get_more[index];
        if(get_more.classList[1] == 'get_more_arr'){
          get_more.classList.remove('get_more_arr');
          get_more.classList.add('get_more_arr2');
          get_more.innerHTML = '收起';
        }else{
          get_more.classList.remove('get_more_arr2');
          get_more.classList.add('get_more_arr');
          get_more.innerHTML = '查看更多';
        }
      },
    },
    beforeRouteEnter(to,from,next){
      window.document.body.style.background  = '#f4f4f4';
      if (/iPhone|mac|iPod|iPad/i.test(navigator.userAgent)) {
        if (to.path !== location.pathname) {
          // 此处不可使用location.replace
          location.assign(to.fullPath)
        } else {
          next()
        }
      }else{
        next();
      }
    },
    beforeRouteLeave(to,from,next){
      window.document.body.style.background = '';
      next();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/orderCheck.vue